import styles from '../../../pages/foryou/_styles/InfoBlock.module.scss';
import { ComponentProps, forwardRef } from "react"

interface IProps {
  pathStroke?: string
  isMobile?: boolean
  shared?: boolean
}

export const SecondaryShare = forwardRef<SVGSVGElement, IProps & ComponentProps<"svg">>(
  ({ isMobile, pathStroke, shared, ...props }, ref) =>
    isMobile ? (
      <svg
        className={styles.secondaryShareIcon}
        xmlns="http://www.w3.org/2000/svg"
        width={29}
        height={25}
        viewBox="0 0 29 25"
        fill={shared ? "#FAFAFA" : "rgba(0, 0, 0, 0)"}
        {...props}
        ref={ref}
      >
        <path
          stroke={pathStroke ? pathStroke : "#fafafa"}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m1.22 24 .058-.03c1.563-2.02 3.099-3.695 5.263-4.826l.001-.001c2.003-1.043 4.457-1.555 7.572-1.65l1.03-.03v6.448c0 .018.006.036.016.05l-.837.548.837-.548a.08.08 0 0 0 .034.03.068.068 0 0 0 .04.005.073.073 0 0 0 .037-.02l11.845-11.411a.086.086 0 0 0 .02-.03l.918.39-.919-.39a.096.096 0 0 0-.02-.103L15.272 1.021V1.02a.074.074 0 0 0-.037-.019.068.068 0 0 0-.04.005.08.08 0 0 0-.034.03l-.837-.549.837.548a.093.093 0 0 0-.015.051v6.412l-.954.045c-4.745.22-8.141 1.976-10.283 5.125-1.798 2.645-2.765 6.396-2.765 11.245 0 .026.01.05.026.065a.072.072 0 0 0 .05.022Z"
        />
      </svg>
    ) : (
      <svg
        className={styles.secondaryShareIcon}
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={22}
        viewBox="0 0 24 22"
        fill={shared ? "#FAFAFA" : "rgba(0, 0, 0, 0)"}
        {...props}
      >
        <path
          stroke={pathStroke ? pathStroke : "#fafafa"}
          strokeWidth={2}
          d="M13.002 6.71191L12.0488 6.75781C8.02686 6.94957 5.1624 8.47305 3.35254 11.2061C1.85267 13.4707 1.02956 16.679 1.00293 20.835C2.29501 19.1412 3.59402 17.7183 5.4082 16.7451L5.41016 16.7441C7.15519 15.8111 9.28479 15.3585 11.9697 15.2744L13.002 15.2422V20.8799L22.9932 10.998L13.002 1.11621V6.71191Z"
        />
      </svg>
    )
)

SecondaryShare.displayName = "IconSecondaryShare"

export default SecondaryShare
